import React from "react";
import blogs from "../../data/blogs.json";
import teams from "../../data/Teams.json";
import BacktoTopCom from "../helpers/BackToTopCom";
import FooterHomeTwo from "../partials/Footers";
import Header from "../partials/Headers";
import AboutSection from "./AboutSection";
import Enquire from "./enquire/Enquire";
import NewsSection from "./NewsSection";
import Services from "./Services";
import OurServices from "./OurServices";
import CounterSection from "./CounterSection";
import CounterTwoSection from "./CounterTwoSection";
import SubscriptionSection from "./SubscriptionSection";
import TeamSection from "./TeamSection";
import WorkprocessSection from "./WorkprocessSection";
import Sponsers from "./Sponsers";
import FeatureSection from "./FeatureSection";
import GallerySection from "./GallerySection";
import VideoPlayer from "./Video";


function Home() {
  return (
    <>
      <div className="video-container">
        <VideoPlayer />
        <Header />
        <Enquire />
      </div>
      <Services />
      <AboutSection />
      <CounterTwoSection />
      <FeatureSection />
      <GallerySection />
      <OurServices />
      <CounterSection />
      <TeamSection teams={teams} />
      <WorkprocessSection />
      <SubscriptionSection />
      <Sponsers />
      <NewsSection blogs={blogs} />
      <FooterHomeTwo />
      <BacktoTopCom />
    </>
  );
}

export default Home;
